import { render, staticRenderFns } from "./orderEdit.vue?vue&type=template&id=5f659190"
import script from "./orderEdit.vue?vue&type=script&lang=js"
export * from "./orderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f659190')) {
      api.createRecord('5f659190', component.options)
    } else {
      api.reload('5f659190', component.options)
    }
    module.hot.accept("./orderEdit.vue?vue&type=template&id=5f659190", function () {
      api.rerender('5f659190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/order/orderEdit.vue"
export default component.exports